import { httpService } from "./http.service";

const BASE_URL = "account/account";

export const accountService = {
  getAll,
  getById,
  create,
  update,
  updateFiles,
  deleteAccount,
  addAccountDesktop,
  inviteUser,
  removeInviteUser,
  removeMemberUser,
  getActiveNotice,
  getListPlans,
  getPlansActive,
  getPlanForAccountId,
  validateDataPlan,
  getCompanyStats,
  getCompanyNameFiles,
  addLog,
  getAccountLogs,
  choicePlan,
  getBetterPlan,
  choiceFreePlan,
  createPreRegistration,
  getPreRegistration,
  createRecords,
  deleteRecord,
  deletePreRegistration,
  updatePreRegistration,
  updateFields,
  updateRecords,
  getInfoAccountsByUserId
  //getCompanyFileUrl
}

async function getAll() {
  const account = await httpService.get(BASE_URL);
  return account;
}

async function getById(id) {
  const account = await httpService.get(`${BASE_URL}/${id}`);
  return account;
}

async function create(objAccount) {
  const account = await httpService.post(`${BASE_URL}/add`, objAccount);
  return account;
}

async function addAccountDesktop(id, objAccount) {
  const account = await httpService.patch(`${BASE_URL}/${id}/add-desktop`, objAccount);
  return account;
}

async function update(id, objAccount) {
  const account = await httpService.patch(`${BASE_URL}/${id}`, objAccount);
  return account;
}

async function updateFiles(id, objAccount) {
  const account = await httpService.patch(`${BASE_URL}/${id}/updateFiles`, objAccount);
  return account;
}

async function deleteAccount(id, objAccount) {
  const account = await httpService.delete(`${BASE_URL}/${id}`, objAccount);
  return account;
}

async function inviteUser(id, inviteData) {
  const updatedAccount = await httpService.patch(`${BASE_URL}/${id}/invite-user`, inviteData);
  return updatedAccount;
}

async function addLog(accountId, field, byMember) {
  const data = await httpService.patch(`${BASE_URL}/${accountId}/add-log`, { field, byMember });
  return data;
}

async function getInfoAccountsByUserId(userId) {
  const data = await httpService.post(`${BASE_URL}/getInfoAccountsByUserId`, { userId });
  return data;
}

async function removeInviteUser(id, email) {
  const updatedAccount = await httpService.patch(`${BASE_URL}/${id}/remove-invite-user`, { email });
  return updatedAccount;
}
async function removeMemberUser(id, userId) {
  try {
    const response = await httpService.patch(`${BASE_URL}/${id}/remove-member`, { userId });

    if (!response || !response.message || !response.members) {
      throw new Error("A resposta da API não contém a lista de membros.");
    }

    return response.members;
  } catch (error) {
    console.error("❌ Erro na função removeMemberUser:", error);
    throw error;
  }
}

async function getActiveNotice() {
  try {
    const data = await httpService.get(`public/ActiveNotice`);
    return data;
  } catch (err) {
    console.error("Erro ao buscar aviso service:", err);
    throw err;
  }
}

export async function getListPlans() {
  try {
    const response = await httpService.get(`public/plans`);
    return response;
  } catch (err) {
    console.error("Erro ao buscar planos:", err);
    throw err;
  }
};


export async function getPlansActive() {
  try {
    const response = await httpService.get(`public/activePlans`);
    return response;
  } catch (err) {
    console.error("Erro ao buscar planos ativos:", err);
    throw err;
  }
};


export async function getPlanForAccountId(id) {
  try {
    const response = await httpService.get(`public/accountPlan/${id}`);
    return response;
  } catch (err) {
    console.error("Erro ao buscar plano:", err);
    throw err;
  }
};

async function validateDataPlan(id, resource, sizeBytes) {
  const data = await httpService.get(`${BASE_URL}/${id}/usage`, { params: { resource, sizeBytes } });
  return data;
}

async function getCompanyStats(id) {
  const data = await httpService.get(`${BASE_URL}/${id}/company-stats`);
  return data;
}

async function getBetterPlan(accountStats, id, planId) {
  const payload = {
    ...accountStats,
    planId
  };
  const data = await httpService.post(`${BASE_URL}/${id}/recommended-plan`, payload);
  return data;
}

async function getPreRegistration(accountId) {
  const { data } = await httpService.get(`${BASE_URL}/${accountId}/getPreRegistration`);
  return data;
}

async function createPreRegistration(accountId, createdBy) {
  const data = await httpService.post(`${BASE_URL}/${accountId}/addPreRegistration`, { createdBy });
  return data;
}

async function updatePreRegistration(accountId, id, userId, payload) {
  const data = await httpService.post(`${BASE_URL}/${accountId}/updatePreRegistration/${id}/user/${userId}`, { payload });
  return data;
}

async function deletePreRegistration(accountId, userId, id) {
  const data = await httpService.delete(`${BASE_URL}/${accountId}/user/${userId}/deletePreRegistration/${id}`);
  return data;
}

async function updateFields(accountId, preRegistrationId, userId, payload) {
  const data = await httpService.post(`${BASE_URL}/${accountId}/updateFields/${preRegistrationId}/user/${userId}`, { payload });
  return data;
}

async function updateRecords(accountId, preRegistrationId, userId, payload) {
  const data = await httpService.put(`${BASE_URL}/${accountId}/pre-registrations/${preRegistrationId}/records/${userId}`, payload);
  return data;
}

async function createRecords(accountId, PreRegistrationId, payload) {
  const data = await httpService.post(`${BASE_URL}/${accountId}/pre-registrations/${PreRegistrationId}/records`, payload);
  return data;
}

async function deleteRecord(accountId, userId, PreRegistrationId, recordId) {
  const data = await httpService.delete(`${BASE_URL}/${accountId}/user/${userId}/preRegistration/${PreRegistrationId}/record/${recordId}`);
  return data;
}

// async function getCompanyNameFiles(id) {
//   const data = await httpService.get(`${BASE_URL}/${id}/company-nameFiles`);
//   return data;
// }
// service
async function getCompanyNameFiles(id, opts = {}) {
  const params = new URLSearchParams();
  if (opts.limit) params.set('limit', String(opts.limit));
  if (opts.offset) params.set('offset', String(opts.offset));
  if (opts.sort) params.set('sort', opts.sort);
  if (opts.dir) params.set('dir', opts.dir);
  if (opts.ext && opts.ext.length) params.set('ext', opts.ext.join(','));
  if (opts.search) params.set('search', opts.search);

  const url = `${BASE_URL}/${id}/company-nameFiles?` + params.toString();
  return await httpService.get(url);
}

// services/accountLog.service.ts
export async function getAccountLogs(accountId, opts = {}) {
  const params = new URLSearchParams();
  if (opts.limit) params.set('limit', String(opts.limit));
  if (opts.offset) params.set('offset', String(opts.offset));
  if (opts.sort) params.set('sort', String(opts.sort));
  if (opts.dir) params.set('dir', String(opts.dir));
  if (opts.action?.length) params.set('action', opts.action.join(','));
  if (opts.byMember) params.set('byMember', opts.byMember);
  if (opts.dateFrom) params.set('dateFrom', String(opts.dateFrom));
  if (opts.dateTo) params.set('dateTo', String(opts.dateTo));
  if (opts.search) params.set('search', opts.search);
  if (opts.type && opts.type !== 'all') params.set('type', String(opts.type));

  const url = `${BASE_URL}/${accountId}/logs?` + params.toString();
  return await httpService.get(url);
}


async function choicePlan(accountId, planId, userId) {
  const data = await httpService.patch(`${BASE_URL}/${accountId}/choicePlanToStart`, { planId, userId });
  return data;
}

async function choiceFreePlan(accountId, planId) {
  return httpService.put(`${BASE_URL}/${accountId}/choiceFreePlan`, { planId });
}

